import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ22_V9: TStep[] = [
  {
    pageId: PageId.SEX_V9,
  },
  {
    pageId: PageId.DOG_AGE_V9,
  },
  {
    pageId: PageId.DOG_BREED_V9,
  },
  {
    pageId: PageId.DOG_BREED_ID_V9,
  },
  {
    pageId: PageId.URGE_V9,
  },
  {
    pageId: PageId.COMMANDS_61_V9,
  },
  {
    pageId: PageId.COMMANDS_62_V9,
  },
  {
    pageId: PageId.COMMANDS_63_V9,
  },
  {
    pageId: PageId.COMMANDS_64_V9,
  },
  {
    pageId: PageId.URGE_2_V9,
  },
  {
    pageId: PageId.POTTY_V9,
  },
  {
    pageId: PageId.BEHAVIOR_V9,
  },
  {
    pageId: PageId.TRAINING_V9,
  },
  {
    pageId: PageId.PREPARE_FLOW_V9,
  },
  {
    pageId: PageId.DOG_STATISTICS_V9,
  },
  {
    pageId: PageId.EMAIL_V9,
  },
  {
    pageId: PageId.CONGRATS_V9,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_V9,
  },
  {
    pageId: PageId.CANCEL_OFFER_V9,
  },
  {
    pageId: PageId.CHAT_UPSELL_V9,
  },
  {
    pageId: PageId.UPSELL_V9,
  },
  {
    pageId: PageId.UPSELL_PITPAT_V9,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_V9,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V9.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V9.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
